import { __assign, __read } from "tslib";
import { ResourceMonitor } from '../../monitors/resource';
import { applyMonitor } from '../../utils';
import { getPluginConfig } from './utils';
export var RESOURCE_MONITOR_PLUGIN_NAME = 'resource';
var defaultConfig = {
    ignoreUrls: [],
    slowSessionThreshold: 4000,
};
export function ResourceMonitorPlugin(client) {
    client.on('init', function () {
        var config = getPluginConfig(client, RESOURCE_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var _a = __read(applyMonitor(ResourceMonitor, config, function (_a) {
            var _b = __read(_a, 2), ev = _b[0], isSlowSession = _b[1];
            client.report(isSlowSession ? __assign(__assign({}, ev), { extra: { sample_rate: 1 } }) : ev);
        }), 1), tearDown = _a[0];
        client.on('beforeDestroy', tearDown);
    });
}
//# sourceMappingURL=resource.js.map